import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  IconButton,
  Paper,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";
import { MedicineWithOrderDetails } from "types/medicine";

import MedicineTable, { MEDICINE_TABLE_HEADERS } from "./MedicineTable";

interface OrderSummaryTableProps {
  medicineCart: MedicineWithOrderDetails[];
  onRemoveFromCart: (index: number) => void;
}

function OrderSummaryTable({
  medicineCart,
  onRemoveFromCart,
}: OrderSummaryTableProps) {
  const { colors } = useCelleraTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        border: `1px solid ${colors.border.main}`,
        borderRadius: 2,
        overflow: "hidden",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          p: 2,
          borderBottom: `1px solid ${colors.border.main}`,
          backgroundColor: colors.background.secondary,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "1rem" }}>
          Order Summary
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: colors.secondary.main,
          }}
        >
          {medicineCart.length} {medicineCart.length === 1 ? "item" : "items"}
        </Typography>
      </Box>

      {/* Table */}
      <MedicineTable
        medicines={medicineCart}
        renderActions={(item, index) => (
          <IconButton
            size="small"
            onClick={() => onRemoveFromCart(index)}
            sx={{
              color: colors.error[500],
              padding: 0.5,
              "&:hover": {
                backgroundColor: colors.error[100],
              },
            }}
            title="Remove from order"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
        emptyState={
          <TableRow>
            <TableCell
              colSpan={MEDICINE_TABLE_HEADERS.length}
              sx={{ border: "none" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "400px",
                  gap: 1,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: colors.text.secondary,
                    textAlign: "center",
                  }}
                >
                  No medicines added to order yet.
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: colors.text.secondary,
                    textAlign: "center",
                  }}
                >
                  Select medicines from the list to add them to your order.
                </Typography>
              </Box>
            </TableCell>
          </TableRow>
        }
        cellPadding={1.5}
        sigMaxWidth={250}
        actionsCellWidth="80px"
        tableContainerProps={{
          sx: { flex: 1, overflow: "auto" },
        }}
      />
    </Paper>
  );
}

export default OrderSummaryTable;
